<template>
    <div class="page-section">
        <slot v-if="this.$slots['containerImmersive']" name="containerImmersive" />
        <v-container v-else class="container--sm">
            <div v-if="this.$slots['tit']" class="page-section--tit-wrap tit-wrap text-center">
                <h2 class="tit tit--lg"><slot name="tit" /></h2>
                <p v-if="this.$slots['txt']" class="txt txt--lg line-height-135"><slot name="txt" /></p>
            </div>
            <slot name="titContents" />
            <slot />
        </v-container>
    </div>
</template>

<script>
export default {
    props: {
        tit: String,
        txt: String,
    },
};
</script>

<style lang="scss" scoped>
// Page Section
.page-section {
    position: relative;
    padding: var(--page-section-padding-y) 0;
    &--first {
        margin-top: calc(var(--page-section-padding-y) * -1);
    }
    &--last {
        margin-bottom: calc(var(--page-section-padding-y) * -1);
    }
    &--xs {
        padding: var(--page-section-padding-y-xs) 0;
    }
    &--sm {
        padding: var(--page-section-padding-y-sm) 0;
        &.page-section {
            &--first {
                margin-top: calc(var(--page-section-padding-y-sm) * -1);
                padding-top: var(--page-section-padding-y-sm);
            }
            &--last {
                margin-bottom: calc(var(--page-section-padding-y-sm) * -1);
                padding-bottom: var(--page-section-padding-y-sm);
            }
        }
    }
    &__bg {
        position: absolute;
        top: 0;
        left: 50%;
        -webkit-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
        z-index: -1;
        display: block;
        width: 100vw;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
    }
}
@media (min-width: 1200px) {
    .page-section {
        &--tit-wrap {
            margin-bottom: 100px;
        }
    }
}
</style>
